import { FcReadingEbook, FcAdvertising } from 'react-icons/fc'
import { FiMusic } from 'react-icons/fi'
import { MdLocalMovies, MdVolunteerActivism, MdOutlineSportsCricket, MdSportsHandball, MdOutlineKitesurfing, MdOutlineAlignHorizontalCenter, MdPets, MdSocialDistance } from 'react-icons/md'
import { AiFillCar } from 'react-icons/ai'
import { SiAmazongames, SiJordan } from 'react-icons/si'
import { IoFitnessSharp, IoExtensionPuzzleSharp } from 'react-icons/io5'
import { BiBookContent } from 'react-icons/bi'
import { GiHomeGarage, GiTheater, GiCampCookingPot, GiBoatFishing, GiAstrolabe, GiGardeningShears, GiHummingbird } from 'react-icons/gi'
import { FaPaintBrush, FaPhotoVideo, FaTheaterMasks, FaBloggerB, FaChalkboardTeacher } from 'react-icons/fa'
import { BsFillBuildingsFill, BsBicycle, BsFillMicFill } from 'react-icons/bs'
import { FcLandscape } from 'react-icons/fc'
import { RxScissors } from 'react-icons/rx'
import { TbGraphOff, TbWritingSign } from 'react-icons/tb'
import { SiPoetry } from 'react-icons/si'
import { BiPhoneCall } from 'react-icons/bi'
import { GrYoga } from 'react-icons/gr'
import { ImAngry } from 'react-icons/im'
import image from './images/couple1.jpg'


const pricingTable = [
    {
        _id: 1,
        title: 'Silver Lovodi',
        unlimitedMsg: "Yes",
        price: 28,
        discount: 10,
        likes: 45,
        sendInterests: 100,
    }, {
        _id: 2,
        title: 'Gold Lovodi',
        unlimitedMsg: "Yes",
        price: 35,
        discount: 10,
        likes: 75,
        sendInterests: 150,
    }, {
        _id: 3,
        title: 'Platinum Lovodi',
        unlimitedMsg: "Yes",
        price: 50,
        discount: 10,
        likes: 100,
        sendInterests: 175,
    }
]

const user =
{
    name: 'Ali Raza',
    email: 'angel@gmail.com',
    phone: '+923003456789',
    id: 'LD12345634',
    photo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU',
    membership: 'Free',
    isVerified: true,
    activitySummary: [
        {
            title: 'Pending Invites',
            value: 10,
        },
        {
            title: 'Accepted Invites',
            value: 0,
        },
        {
            title: 'Recent Visitors',
            value: 0,
        },
        {
            title: 'Contacts Viewed',
            value: 0,
        },
        {
            title: 'Chats Initiated',
            value: 0,
        },
    ],
    height: "5'8\"",
    maritalStatus: 'Never Married',
    religion: 'Islam',
    community: 'Rajput',
    subCommunity: 'Awan',
    motherTongue: 'Urdu',
    countryLiving: 'Pakistan',
    grewUpIn: 'Pakistan',
    city: 'Lahore',
    dob: '13/01/2002',
    lookingFor: 'Bride',
    aboutMe: "Glad you'd like to know me better. Post my academics, I work as a Software Developer.I share a close bond with my family members. I am looking for an understanding and loving partner who will respect my family and support me in every phase of life. Please feel free to contact me if interested.",
    bloodGroup: '',
    disability: "None",
    diet: "Non-Vegetarian",
    healthInfo: "",
    familyLocation: 'Lahore, Pakistan',
    fatherStatus: "",
    motherStatus: "",
    brothers: "",
    sisters: "",
    familyType: "",
    familyValues: "",
    familyAffluence: "",
    qualification: "Bs Computer Science",
    college: "COMSATS",
    yearlyOrMonthly: "Yearly",
    income: "Rs. 0 - 1 Lakh",
    occupation: "Software Developer",
    company: "Techlogix",
    workingWith: "Private Company",
    newMatches: [],
    shortlisted: [],
    ignored: [],
    blocked: [],
    recentlyViewed: [{
        name: 'Sana',
        photo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU',
        uid: 'LD77745634',
        age: 18,
        height: "5'8\"",
        motherTongue: 'Urdu',
        city: 'Lahore',
        occupation: 'Student',
        religion: 'Islam',
        lookingFor: 'Bride',
        aboutMe: "Glad you'd like to know me better. Post my academics, I work as a Software Developer.I share a close bond with my family members. I am looking for an understanding and loving partner who will respect my family and support me in every phase of life. Please feel free to contact me if interested.",
        familyLocation: 'Lahore, Pakistan',
        maritalStatus: 'Never Married',
        community: 'Rajput',
        subCommunity: 'Awan',
        country: 'Pakistan',
        isVerified: true,
        isOnline: true,
        profileBy: 'Self',
        qualification: "Bs Computer Science",
        college: "COMSATS",
        yearlyOrMonthly: "Yearly",
        income: "Rs. 0 - 1 Lakh",
        company: "Techlogix",
        workingWith: "Private Company",
        email: 'angel@gmail.com',
        phone: '+923003456789',
        chemistry: [
            "You both are from the same community",
            "You both are from the same city",
            "You both are from the same country",
            "You both are from the same religion",
            "You both have the same mother tongue",
            "You both are from the same age group",
        ]
    },
    ],
    recentVisitors: [],
    premiumMatches: [],
    mayLike: [],
    interests: {
        hobbies: ['Reading / Book clubs', 'Listening to music', 'Movies', 'Travel / Sightseeing', 'Sports - Outdoor', 'Sports - Indoor',]
    },
    notifications: [
        {
            nid: 1,
            name: 'Sana',
            photo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU',
            uid: 'LD77745634',
            time: 'a few hours ago',
            message: ' added a photo to her profile',
        },
        {
            nid: 2,
            name: 'Saima',
            photo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU',
            uid: 'LD78845634',
            time: 'a few hours ago',
            message: 'acquired phone verified status',
        },
        {
            nid: 3,
            name: 'Sana',
            photo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU',
            uid: 'LD77745634',
            time: 'a few hours ago',
            message: ' added a photo to her profile',
        },
        {
            nid: 4,
            name: 'Saima',
            photo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU',
            uid: 'LD78845634',
            time: 'a few hours ago',
            message: 'acquired phone verified status',
        },
        {
            nid: 5,
            name: 'Sana',
            photo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU',
            uid: 'LD77745634',
            time: 'a few hours ago',
            message: ' added a photo to her profile',
        },
    ],
    matches: [
        {
            name: 'Sana',
            photo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU',
            uid: 'LD77745634',
            age: 18,
            height: "5'8\"",
            interests: {
                hobbies: ['Reading / Book clubs', 'Listening to music', 'Movies', 'Travel / Sightseeing', 'Sports - Outdoor', 'Sports - Indoor',]
            },
            motherTongue: 'Urdu',
            city: 'Lahore',
            occupation: 'Student',
            religion: 'Islam',
            lookingFor: 'Bride',
            aboutMe: "Glad you'd like to know me better. Post my academics, I work as a Software Developer.I share a close bond with my family members. I am looking for an understanding and loving partner who will respect my family and support me in every phase of life. Please feel free to contact me if interested.",
            familyLocation: 'Lahore, Pakistan',
            maritalStatus: 'Never Married',
            community: 'Rajput',
            subCommunity: 'Awan',
            country: 'Pakistan',
            isVerified: true,
            isOnline: true,
            profileBy: 'Self',
            qualification: "Bs Computer Science",
            college: "COMSATS",
            yearlyOrMonthly: "Yearly",
            income: "Rs. 0 - 1 Lakh",
            company: "Techlogix",
            workingWith: "Private Company",
            email: 'angel@gmail.com',
            phone: '+923003456789',
            chemistry: [
                "You both are from the same community",
                "You both are from the same city",
                "You both are from the same country",
                "You both are from the same religion",
                "You both have the same mother tongue",
                "You both are from the same age group",
            ]
        },
        {
            name: 'Sana',
            photo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU',
            uid: 'LD77745634',
            age: 18,
            height: "5'8\"",
            motherTongue: 'Urdu',
            city: 'Lahore',
            occupation: 'Student',
            religion: 'Islam',
            lookingFor: 'Bride',
            aboutMe: "Glad you'd like to know me better. Post my academics, I work as a Software Developer.I share a close bond with my family members. I am looking for an understanding and loving partner who will respect my family and support me in every phase of life. Please feel free to contact me if interested.",
            familyLocation: 'Lahore, Pakistan',
            maritalStatus: 'Never Married',
            community: 'Rajput',
            subCommunity: 'Awan',
            country: 'Pakistan',
            isVerified: true,
            chemistry: [
                "You both are from the same community",
                "You both are from the same city",
                "You both are from the same country",
                "You both are from the same religion",
                "You both have the same mother tongue",
                "You both are from the same age group",
            ]
        },
        {
            name: 'Sana',
            photo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU',
            uid: 'LD77745634',
            age: 18,
            height: "5'8\"",
            motherTongue: 'Urdu',
            city: 'Lahore',
            occupation: 'Student',
            religion: 'Islam',
            lookingFor: 'Bride',
            aboutMe: "Glad you'd like to know me better. Post my academics, I work as a Software Developer.I share a close bond with my family members. I am looking for an understanding and loving partner who will respect my family and support me in every phase of life. Please feel free to contact me if interested.",
            familyLocation: 'Lahore, Pakistan',
            maritalStatus: 'Never Married',
            community: 'Rajput',
            subCommunity: 'Awan',
            country: 'Pakistan',
            isVerified: true,
            chemistry: [
                "You both are from the same community",
                "You both are from the same city",
                "You both are from the same country",
                "You both are from the same religion",
                "You both have the same mother tongue",
                "You both are from the same age group",
            ]
        },
        {
            name: 'Sana',
            photo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU',
            uid: 'LD77745634',
            age: 18,
            height: "5'8\"",
            motherTongue: 'Urdu',
            city: 'Lahore',
            residencyStatus: 'Citizen',
            occupation: 'Student',
            religion: 'Islam',
            lookingFor: 'Bride',
            aboutMe: "Glad you'd like to know me better. Post my academics, I work as a Software Developer.I share a close bond with my family members. I am looking for an understanding and loving partner who will respect my family and support me in every phase of life. Please feel free to contact me if interested.",
            familyLocation: 'Lahore, Pakistan',
            maritalStatus: 'Never Married',
            community: 'Rajput',
            subCommunity: 'Awan',
            country: 'Pakistan',
            isVerified: true,
            chemistry: [
                "You both are from the same community",
                "You both are from the same city",
                "You both are from the same country",
                "You both are from the same religion",
                "You both have the same mother tongue",
                "You both are from the same age group",
            ]
        },
        {
            name: 'Sana',
            photo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU',
            uid: 'LD77745634',
            age: 18,
            height: "5'8\"",
            motherTongue: 'Urdu',
            city: 'Lahore',
            occupation: 'Student',
            religion: 'Islam',
            lookingFor: 'Bride',
            aboutMe: "Glad you'd like to know me better. Post my academics, I work as a Software Developer.I share a close bond with my family members. I am looking for an understanding and loving partner who will respect my family and support me in every phase of life. Please feel free to contact me if interested.",
            familyLocation: 'Lahore, Pakistan',
            maritalStatus: 'Never Married',
            community: 'Rajput',
            subCommunity: 'Awan',
            country: 'Pakistan',
            isVerified: true,
            chemistry: [
                "You both are from the same community",
                "You both are from the same city",
                "You both are from the same country",
                "You both are from the same religion",
                "You both have the same mother tongue",
                "You both are from the same age group",
            ]
        },
    ],
    partner: {
        age: "18-25",
        height: "5'8\" - 6'0\"",
        motherTongue: ["Urdu ", "Punjabi"],
        religion: ["Islam", "Hindu"],
        community: ["Arain", "Malik"],
        maritalStatus: "Never Married",
        countryLiving: ["Pakistan", "India"],
        city: "Doesn't matter",
        qualification: "Doesn't matter",
        occupation: "Doesn't matter",
        workingWith: "Doesn't matter",
        workingAs: "Doesn't matter",
        income: "Doesn't matter",
        diet: "Doesn't matter",
        residencyStatus: 'Citizen / Permanent Resident',
        countryGrewUp: "Pakistan",
    },
    photos: [
        {
            url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU'
        },
        {
            url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU'
        },
        {
            url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU'
        },
        {
            url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU'
        },
        {
            url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRudDbHeW2OobhX8E9fAY-ctpUAHeTNWfaqJA&usqp=CAU'
        },
    ]
}
const coupleSlider = [
    {
        image: image,
        title: 'Ali & Sana',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, voluptatum.'
    },
    {
        image: 'https://img.shaadi.com/success-story/3SH87233474-FSH54740347-big.jpg',
        title: 'Usman & Ayesha',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, voluptatum.'
    },
    {
        image: 'https://img.shaadi.com/success-story/fSH95419402-fSH81178668-big.jpg',
        title: "Uzair & Ariba",
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, voluptatum.'
    },
    {
        image: "https://img.shaadi.com/success-story/9SH31655343-FSH00015566-big.jpg",
        title: 'Asif & Aneeza',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, voluptatum.'
    },
    {
        image: "https://img.shaadi.com/success-story/aSH66205273-GSH16346305-big.jpg",
        title: 'Raza & Ansha',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, voluptatum.'
    },
]

const hobbies = [
    {
        id: 1,
        value: 'Reading / Book clubs',
        icon: <FcReadingEbook />
    },
    {
        id: 2,
        value: 'Listening to music',
        icon: <FiMusic />
    },
    {
        id: 3,
        value: 'Movies',
        icon: <MdLocalMovies />
    },
    {
        id: 4,
        value: 'Travel / Sightseeing',
        icon: <AiFillCar />
    },
    {
        id: 5,
        value: 'Sports - Outdoor',
        icon: <MdOutlineSportsCricket />
    },
    {
        id: 6,
        value: 'Sports - Indoor',
        icon: <MdSportsHandball />
    },
    {
        id: 7,
        value: 'Video / Computer games',
        icon: <SiAmazongames />
    },
    {
        id: 8,
        value: 'Health & Fitness',
        icon: <IoFitnessSharp />
    },
    {
        id: 9,
        value: 'Content creation',
        icon: <BiBookContent />
    },
    {
        id: 10,
        value: 'Net surfing',
        icon: <MdOutlineKitesurfing />
    },
    {
        id: 11,
        value: 'Enterpreneurship',
        icon: <MdOutlineAlignHorizontalCenter />
    },
    {
        id: 12,
        value: 'Cooking',
        icon: <GiCampCookingPot />
    },
    {
        id: 13,
        value: 'Painting / Drawing',
        icon: <FaPaintBrush />
    },
    {
        id: 14,
        value: 'Pets',
        icon: <MdPets />
    },
    {
        id: 15,
        value: 'Photography',
        icon: <FaPhotoVideo />
    },
    {
        id: 16,
        value: 'Model building',
        icon: <BsFillBuildingsFill />
    },
    {
        id: 17,
        value: 'Social Service',
        icon: <MdSocialDistance />
    },
    {
        id: 18,
        value: 'Fishing',
        icon: <GiBoatFishing />
    },
    {
        id: 19,
        value: 'Landscaping',
        icon: <FcLandscape />
    },
    {
        id: 20,
        value: 'Home / Interior decoration',
        icon: <GiHomeGarage />
    },
    {
        id: 21,
        value: 'DIY projects',
        icon: <RxScissors />
    },
    {
        id: 22,
        value: 'Astrology / Numerology',
        icon: <GiAstrolabe />
    },
    {
        id: 23,
        value: 'Graphology',
        icon: <TbGraphOff />
    },
    {
        id: 24,
        value: 'Gardening',
        icon: <GiGardeningShears />
    },
    {
        id: 25,
        value: 'Bird watching',
        icon: <GiHummingbird />
    },
    {
        id: 26,
        value: 'Dancing',
        icon: <SiJordan />
    },
    {
        id: 27,
        value: 'Acting',
        icon: <FaTheaterMasks />
    },
    {
        id: 28,
        value: 'Singing',
        icon: <FcAdvertising />
    },
    {
        id: 29,
        value: 'Cycling',
        icon: <BsBicycle />
    },
    {
        id: 30,
        value: 'Solving puzzles',
        icon: <IoExtensionPuzzleSharp />
    },
    {
        id: 31,
        value: 'Writing',
        icon: <TbWritingSign />
    },
    {
        id: 32,
        value: 'Poetry',
        icon: <SiPoetry />
    },
    {
        id: 33,
        value: 'Theatre',
        icon: <GiTheater />
    },
    {
        id: 34,
        value: 'Volunteering / Social Service',
        icon: <MdVolunteerActivism />
    },
    {
        id: 35,
        value: 'Politics',
        icon: <BiPhoneCall />
    },
    {
        id: 36,
        value: 'Anime / Manga',
        icon: <ImAngry />
    },
    {
        id: 37,
        value: 'Teaching / Academic',
        icon: <FaChalkboardTeacher />
    },
    {
        id: 38,
        value: 'Stand-up comedy',
        icon: <BsFillMicFill />
    },
    {
        id: 39,
        value: 'Blogging',
        icon: <FaBloggerB />
    },
    {
        id: 40,
        value: 'Yoga / Meditation',
        icon: <GrYoga />
    }
]

const languageList = ["English", "Spanish", "Mandarin Chinese", "Hindi", "Arabic", "Bengali", "Russian", "Portuguese", "Japanese", "German", "French", "Korean", "Italian", "Turkish", "Polish", "Ukrainian", "Romanian", "Dutch", "Swedish", "Czech", "Indonesian", "Greek", "Danish", "Norwegian", "Finnish", "Hungarian", "Swahili", "Hebrew", "Thai", "Catalan", "Serbian", "Slovak", "Bulgarian", "Croatian", "Icelandic", "Lithuanian", "Latvian", "Slovenian", "Estonian", "Vietnamese", "Albanian", "Macedonian", "Farsi", "Urdu", "Kurdish", "Bosnian", "Malay", "Haitian Creole", "Luxembourgish", "Afrikaans", "Gujarati", "Welsh", "Yiddish", "Quechua", "Basque", "Galician", "Armenian", "Amharic", "Igbo", "Zulu", "Tswana", "Xhosa", "Somali", "Oromo", "Kinyarwanda", "Kazakh", "Mongolian", "Tajik", "Kyrgyz", "Tibetan", "Uighur"]
const heightList = ["3'0\"", "3'1\"", "3'2\"", "3'3\"", "3'4\"", "3'5\"", "3'6\"", "3'7\"", "3'8\"", "3'9\"", "3'10\"", "3'11\"", "4'0\"", "4'1\"", "4'2\"", "4'3\"", "4'4\"", "4'5\"", "4'6\"", "4'7\"", "4'8\"", "4'9\"", "4'10\"", "4'11\"", "5'0\"", "5'1\"", "5'2\"", "5'3\"", "5'4\"", "5'5\"", "5'6\"", "5'7\"", "5'8\"", "5'9\"", "5'10\"", "5'11\"", "6'0\"", "6'1\"", "6'2\"", "6'3\"", "6'4\"", "6'5\"", "6'6\"", "6'7\"", "6'8\"", "6'9\"", "6'10\"", "6'11\"", "7'0\"", "7'1\"", "7'2\"", "7'3\"", "7'4\"", "7'5\"", "7'6\"", "7'7\"", "7'8\"", "7'9\"", "7'10\"", "7'11\"", "8'0\""]

const qualificationList = ["Bachelors", "Masters", "Doctorate", "Diploma", "Associates degree", "Honours degree", "Trade school", "High school", "Less than high school", "Professional degree", "Other"];
const workingWithList = ["Government / Public Sector", "Defense / Civil Services", "Business / Self Employed", "Private Company", "Not Working", "Student", "Retired", "Unemployed", "Others"];
const occupationList = ["Accountant",
    "Advertising executive",
    "Architect",
    "Attorney",
    "Computer engineer",
    "Consultant",
    "Dentist",
    "Doctor",
    "Engineer",
    "Financial analyst",
    "Human resources manager",
    "Journalist",
    "Marketing manager",
    "Nurse",
    "Pharmacist",
    "Physician assistant",
    "Police officer",
    "Project manager",
    "Real estate agent",
    "Registered nurse",
    "Software developer",
    "Surgeon",
    "Teacher",
    "Web developer",
    "Hardware & Networking professional",
    "Merchant Naval Officer",
    "Mariner",
    "Marketing Professional",
    "Sales Professional",
    "Media Professional",
    "Advertising Professional",
    "Event Manager",
    "Public Relations Professional",
    "Air Hostess / Flight Attendant",
    "Pilot / Co-Pilot",
    "Other Airline Professional",
    "IAS / IRS / IES / IFS",
    "Police Services (PS)",
    "Law Enforcement Employee (Others)",
    "Catering Professional",
    "Chef / Sommelier / Food Critic",
    "Hotel & Hospitality Professional (Others)",
    "Civil Engineer",
    "Electronics / Telecom Engineer",
    "Mechanical / Production Engineer",
    "Non IT Engineer (Others)",
    "Designer (Others)",
    "Artist (Others)",
    "Beautician",
    "Fashion Designer",
    "Interior Designer",
    "Other Designer (Others)"
];

const incomeList = ["No Income", "USD 0 - 100", "USD 100 - 500", "USD 500 - 1000", "USD 1000 - 2000", "USD 2000 - 3000", "USD 3000 - 5000", "USD 5000 - 10000", "USD 10000 - 20000", "USD 20000 - 50000", "USD 50000 - 100000", "USD 100000 - 500000", "USD 500000 - 1000000", "USD 1000000+"];

const religionAndCommunityList = [
    {
        religion: "Chinese",
        castes: [
            "Han Chinese",
            "Hui",
            "Manchu",
            "Miao",
            "Mongols",
            "Tibetans",
            "Uyghurs",
            "Zhuang",
            "Other"
        ]
    },
    {
        religion: "Hindu",
        castes: [
            "24 Manai Telugu Chettiar",
            "96 Kuli Maratha",
            "96K Kokanastha",
            "Adi Andhra",
            "Adi Dharmi",
            "Adi Dravida",
            "Adi Karnataka",
            "Agamudayar",
            "Agarwal",
            "Agnikula Kshatriya",
            "Agri",
            "Ahir",
            "Ahom",
            "Ambalavasi",
            "Arcot",
            "Arekatica",
            "Arora",
            "Arunthathiyar",
            "Arya Vysya",
            "Aryasamaj",
            "Ayyaraka",
            "Badaga",
            "Baghel/Pal/Gaderiya",
            "Bahi",
            "Baidya",
            "Baishnab",
            "Baishya",
            "Bajantri",
            "Balija",
            "Balija - Naidu",
            "Banayat Oriya",
            "Banik",
            "Baniya",
            "Barai",
            "Bari",
            "Barnwal",
            "Barujibi",
            "Bengali",
            "Besta",
            "Bhandari",
            "Bhatia",
            "Bhatraju",
            "Bhavsar",
            "Bhovi",
            "Billava",
            "Boya/Nayak/Naik",
            "Boyer",
            "Brahmbatt",
            "Brahmin",
            "Brahmin - Anavil",
            "Brahmin - Audichya",
            "Brahmin - Barendra",
            "Brahmin - Bengali",
            "Brahmin - Bhatt",
            "Brahmin - Bhumihar",
            "Brahmin - Brahmbhatt",
            "Brahmin - Dadhich/Dadheech",
            "Brahmin - Daivadnya",
            "Brahmin - Danua",
            "Brahmin - Deshastha",
            "Brahmin - Dhiman",
            "Brahmin - Dravida",
            "Brahmin - Embrandiri",
            "Brahmin - Garhwali",
            "Brahmin - Goswami",
            "Brahmin - Gour",
            "Brahmin - Gowd Saraswat",
            "Brahmin - Gujar Gour",
            "Brahmin - Gurukkal",
            "Brahmin - Halua",
            "Brahmin - Havyaka",
            "Brahmin - Himachali",
            "Brahmin - Hoysala",
            "Brahmin - Iyengar",
            "Brahmin - Iyer",
            "Brahmin - Jangid",
            "Brahmin - Jhadua",
            "Brahmin - Jhijhotiya",
            "Brahmin - Kannada Madhva",
            "Brahmin - Kanyakubja",
            "Brahmin - Karhade",
            "Brahmin - Kashmiri Pandit",
            "Brahmin - Kokanastha",
            "Brahmin - Kota",
            "Brahmin - Kulin",
            "Brahmin - Kumaoni",
            "Brahmin - Madhwa",
            "Brahmin - Maharashtrian",
            "Brahmin - Maithili",
            "Brahmin - Modh",
            "Brahmin - Mohyal",
            "Brahmin - Nagar",
            "Brahmin - Namboodiri",
            "Brahmin - Niyogi",
            "Brahmin - Niyogi Nandavariki",
            "Brahmin - Other",
            "Brahmin - Paliwal",
            "Brahmin - Panda",
            "Brahmin - Pandit",
            "Brahmin - Pareek",
            "Brahmin - Pushkarna",
            "Brahmin - Rarhi",
            "Brahmin - Rigvedi",
            "Brahmin - Rudraj",
            "Brahmin - Sakaldwipi",
            "Brahmin - Sanadya",
            "Brahmin - Sanketi",
            "Brahmin - Saraswat",
            "Brahmin - Saryuparin",
            "Brahmin - Shivhalli",
            "Brahmin - Shrimali",
            "Brahmin - Sikhwal",
            "Brahmin - Siriyavan",
            "Brahmin - Smartha",
            "Brahmin - Sri Vaishnava",
            "Brahmin - Stanika",
            "Brahmin - Sthapathy",
            "Brahmin - Sthanika",
            "Brahmin - Tapodhan",
            "Brahmin - Telugu",
            "Brahmin - Tyagi",
            "Brahmin - Utkal",
            "Brahmin - Vaidiki",
            "Brahmin - Vaikhanasa",
            "Brahmin - Valam",
            "Brahmin - Velanadu",
            "Brahmin - Vishwakarma",
            "Brahmin - Vyas",
            "Brahmin - Yajurvedi",
            "Brahmin - Yerukala",
            "Brahmin - Yezhava",
            "Brahmin - Zalora",
            "Budaga Jangam",
            "Bunt (Shetty)",
            "CKP",
            "Chakkala",
            "Chamar",
            "Chandala",
            "Chasa",
            "Chaudary",
            "Chaurasia",
            "Chaurasias",
            "Cheramar",
            "Chettiar",
            "Chettiyar",
            "Chhetri",
            "Chippolu (Mera)",
            "Chitpavan",
            "Christians - All",
            "Christians - Born Again",
            "Christians - Catholic",
            "Christians - Knanaya",
            "Christians - Latin Catholic",
            "Christians - Malankara",
            "Christians - Marthoma",
            "Christians - Others",
            "Christians - Pentacost",
            "Christians - Protestant",
            "Coorgi",
            "Coorgi - Protestant",
            "DNT",
            "Daivadiga",
            "Dasapalanjika",
            "Devadiga",
            "Devang Koshthi",
            "Devanga",
            "Devendra Kula Vellalar",
            "Devendra Kula Velalar",
            "Devendra Kula Vellalars",
            "Devendra Kula Vellalas",
            "Devendra Kula Vellalar Maha Sabha",
            "Dhangar",
            "Dharkar",
            "Dheevara",
            "Dhiman Brahmin",
            "Dhoba",
            "Dommala",
            "Dummala",
            "Dusadh",
            "Edigas",
            "Ezhava",
            "Ezhuthachan",
            "GSB",
            "Gajula",
            "Ganiga",
            "Ganiga - Cholasani",
            "Ganiga - Poojary",
            "Ganiga - Suvarna",
            "Ganjam",
            "Garhwali",
            "Gavara",
            "Goud",
            "Gounder",
            "Gounder - Nattu Gounder",
            "Gounder - Others",
            "Gounder - Pattanavar",
            "Gounder - Urali Gounder",
            "Gounder - Vanniya Kula Kshatriyar",
            "Gounder - Vettuva Gounder",
            "Gowda",
            "Gramani",
            "Gujarati",
            "Gujarati - Audichya",
            "Gujarati - Baniya",
            "Gujarati - Bhatia",
            "Gujarati - Brahmin",
            "Gujarati - Kapol",
            "Gujarati - Khatri",
            "Gujarati - Lohana",
            "Gujarati - Patel",
            "Gujarati - Rajput",
            "Gujarati - Sindhi",
            "Gujarati - Vaishnav",
            "Gupta",
            "Gurav",
            "Gursikh",
            "Gurung",
            "Hegde",
            "Idu Mishmi",
            "Intercaste",
            "Intercaste - Anglo Indian",
            "Intercaste - Other",
            "Intercaste - SC/ST",
            "Jaiswal",
            "Jain",
            "Jain - Agarwal",
            "Jain - Bania",
            "Jain - Digambar",
            "Jain - Gujarati",
            "Jain - Intercaste",
            "Jain - Khandelwal",
            "Jain - Kutchi",
            "Jain - Marwari",
            "Jain - Oswal",
            "Jain - Porwal",
            "Jain - Unspecified",
            "Jain - Vaishnav",
            "Jain - Vania",
            "Jaiswal",
            "Jangam",
            "Jat",
            "Jat - Sikh",
            "Jatav",
            "Jogi (Nath)",
            "KKC",
            "Kaibarta",
            "Kalar",
            "Kalinga",
            "Kallar",
            "Kallu",
            "Kalwar",
            "Kamboj",
            "Kamma",
            "Kanakkan",
            "Kansari",
            "Kansyakaar",
            "Kapu",
            "Karana",
            "Karmakar",
            "Karuneegar",
            "Karuneegar Chettiar",
            "Kasar",
            "Kashyap",
            "Katiya",
            "Kayastha",
            "Khandayat",
            "Khandelwal",
            "Kharwar",
            "Khatri",
            "Khatri - Arora",
            "Khatri - Bhatia",
            "Khatri - Kapoor",
            "Khatri - Khanna",
            "Khatri - Kukreja",
            "Khatri - Mehra",
            "Khatri - Suri",
            "Khatri - Taneja",
            "Khatri - Vohra",
            "Khatris",
            "Khatris - Arora",
            "Khatris - Bhatia",
            "Khatris - Kapoor",
            "Khatris - Khanna",
            "Khatris - Kukreja",
            "Khatris - Mehra",
            "Khatris - Suri",
            "Khatris - Taneja",
            "Khatris - Vohra",
            "Kheeri",
            "Khoja",
            "Khoja - Ismaili",
            "Khoja - Shia",
            "Khoja - Sunni",
            "Koiri",
            "Konar",
            "Koppula Velama",
            "Koshti",
            "Kovil Kallar",
            "Kshatriya",
            "Kshatriya - Bhavsar",
            "Kshatriya - Kutchi",
            "Kshatriya - Maratha",
            "Kshatriya - Rajput",
            "Kumawat",
            "Kumhar",
            "Kuravan",
            "Kuruva",
            "Kuruhina Shetty",
            "Kuruhinashetty",
            "Kuruma",
            "Kurup",
            "Kurva",
            "Kutchi",
            "Lambadi",
            "Lingayat",
            "Lodhi Rajput",
            "Lohar",
            "Lohana",
            "Lubana",
            "Maadhava",
            "Madhesiya",
            "Madiga",
            "Mahajan",
            "Mahar",
            "Maharashtrian",
            "Maheshwari",
            "Mahishya",
            "Majabi",
            "Mali",
            "Mallah",
            "Mangalorean",
            "Manipuri",
            "Marar",
            "Maratha",
            "Maratha - 96K Kokanastha",
            "Maratha - Agri",
            "Maratha - Bhavsar",
            "Maratha - Chambhar",
            "Maratha - CKP",
            "Maratha - Deshastha",
            "Maratha - Dhangar",
            "Maratha - Gomantak",
            "Maratha - Gurav",
            "Maratha - Jangam",
            "Maratha - Karhade",
            "Maratha - Kasar",
            "Maratha - Kokanastha",
            "Maratha - Koli",
            "Maratha - Kumbhar",
            "Maratha - Lohar",
            "Maratha - Mali",
            "Maratha - Maratha Kunbi",
            "Maratha - Matang",
            "Maratha - Nhavi",
            "Maratha - Panchal",
            "Maratha - Parit",
            "Maratha - Patil",
            "Maratha - Sutar",
            "Maratha - Thakur",
            "Maratha - Tili",
            "Maratha - Vaishya Vani",
            "Maratha - Vanjari",
            "Maratha - Vani",
            "Maratha - Vishwakarma",
            "Maratha - Warakari",
            "Maratha - Yajurvedi",
            "Maratha Kunbi",
            "Maruthuvar",
            "Matang",
            "Mathur",
            "Mathur Vaishya",
            "Maurya",
            "Meghwal",
            "Mehra",
            "Menon",
            "Mera",
            "Meru Darji",
            "Meru Thandan",
            "Meru Thandan - Gopala",
            "Meru Thandan - Marar",
            "Meru Thandan - Pisharody",
            "Meru Thandan - Poduval",
            "Meru Thandan - Tharakan",
            "Mochi",
            "Modak",
            "Mogaveera",
            "Mudaliar",
            "Mudaliar - Arcot",
            "Mudaliar - Saiva Pillai",
            "Mudaliar - Senguntha",
            "Mudaliar - Thuluva Vellala",
            "Mudaliar - Vannia Kula Kshatriyar",
            "Mudaliar - Vellalar",
            "Mukkulathor",
            "Munda",
            "NRI",
            "Nadar",
            "Naidu",
            "Naik",
            "Nair",
            "Namasudra",
            "Napit",
            "Nhavi",
            "Nishad",
            "Oswal",
            "Otari",
            "Panchal",
            "Panicker",
            "Pannayar",
            "Paravan",
            "Paravar",
            "Pasi",
            "Patel",
            "Patidar",
            "Patra",
            "Perika",
            "Pillai",
            "Pisharody",
            "Poduval",
            "Porwal",
            "Prajapati",
            "Pulaya",
            "Rajaka",
            "Rajasthani",
            "Rajbonshi",
            "Rajput",
            "Ramdasia",
            "Ramgariah",
            "Ravidasia",
            "Reddy",
            "Sadgope",
            "Saha",
            "Sahu",
            "Saini",
            "Saliya",
            "Saraswat",
            "Sardar",
            "Savji",
            "Senai Thalaivar",
            "Shilpkar",
            "Sindhi",
            "Sindhi - Amil",
            "Sindhi - Bhatia",
            "Sindhi - Chhapru",
            "Sindhi - Dadu",
            "Sindhi - Hyderabadi",
            "Sindhi - Larkana",
            "Sindhi - Lariba",
            "Sindhi - Lohana",
            "Sindhi - Rohiri",
            "Sindhi - Sahiti",
            "Sindhi - Sahiti - Dhaulya",
            "Sindhi - Sakkhar",
            "Sindhi - Sehwani",
            "Sindhi - Shikarpuri",
            "Sindhi - Sindhi Bhaiband",
            "Sindhi - Thatai",
            "Sonar",
            "Soni",
            "Sourashtra",
            "Sozhia Vellalar",
            "Srisayani",
            "Srisayani Brahmin",
            "Sudra",
            "Sugali",
            "Suvarna",
            "Swarnakar",
            "Swarnkar",
            "Syed",
            "Tamil Yadava",
            "Tanti",
            "Telaga",
            "Teli",
            "Thakkar",
            "Thakore",
            "Thakur",
            "Thiyya",
            "Tili",
            "Turupu Kapu",
            "Unspecified",
            "Vaddera",
            "Vaish",
            "Vaishnava",
            "Vaishnavi",
            "Vaishnavi Vani",
            "Vaishnavi Vysya",
            "Vaishnavi-Vania",
            "Vaishnavi-Vysya",
            "Vaishnavi-Vysya Brahmin",
            "Vaishnavi-Vysya Vanika",
            "Vaishnavi-Vysya Vanika Chettiar",
            "Vaishnavi-Vysya-Vanika",
            "Vaishnavi-Vysya-Vanika Chettiar",
            "Vaishnava",
            "Vaishya",
            "Vaishya - Agarwal",
            "Vaishya - Baniya",
            "Vaishya - Gujarati",
            "Vaishya - Jain",
            "Vaishya - Khandelwal",
            "Vaishya - Maheshwari",
            "Vaishya - Oswal",
            "Vaishya - Porwal",
            "Vaishya - Vaishnav",
            "Vaishya - Vaniya",
            "Vaishya - Vaniya Chettiar",
            "Vaishya - Vysya",
            "Vaishya - Vysya Brahmin",
            "Vaishya - Vysya Vanika",
            "Vaishya - Vysya Vanika Chettiar",
            "Vaishya - Vysya-Vanika",
            "Vaishya - Vysya-Vanika Chettiar",
            "Vaishya - Vysya-Vanika-Chettiar",
            "Valmiki",
            "Vallala",
            "Valluvan",
            "Vania",
            "Vaniya",
            "Vaniya Chettiar",
            "Vanjara",
            "Vanjari",
            "Vanjari - Bhatraju",
            "Vanjari - Lohar",
            "Vanjari - Lohara",
            "Vanjari - Veershaiva",
            "Vannar",
            "Vannia Kula Kshatriyar",
            "Vanniyakula Kshatriya",
            "Vanniyar",
            "Vanniyar - Gounder",
            "Varshney",
            "Vellalar",
            "Vellalar - Gounder",
            "Vellalar - Pillai",
            "Vellalar - Vannia Kula Kshatriyar",
            "Vellalar - Veershaiva",
            "Vellalar - Velan",
            "Vellama",
            "Vellama - Kamma",
            "Veluthedathu Nair",
            "Vettuva Gounder",
            "Vishwakarma",
            "Vishwakarma - Mali",
            "Vishwakarma - Suthar",
            "Viswakarma",
            "Vokkaliga",
            "Vysya",
            "Vysya Brahmin",
            "Vysya Vanika",
            "Vysya Vanika Chettiar",
            "Vysya-Vanika",
            "Vysya-Vanika Chettiar",
            "Vysya-Vanika-Chettiar",
            "Yadav",
            "Yadav - Ahir",
            "Yadav - Golla",
            "Yadav - Gowda",
            "Yadav - Kuruba",
            "Yadav - Naidu",
            "Yadav - Nandvanshi",
            "Yadav - Raja",
            "Yadav - Rajput",
            "Yadav - Thakur",
            "Yadav - Yaday",
            "Yerukala",
            "Yerukula",
            "Yezhava",
            "Yezhava - Kavara",
            "Yezhava - Pattarya",
            "Yezhava - Raja",
            "Yezhava - Sambhava",
            "Yezhava - Thandan",
            "Yezhava - Vannan",
            "Yezhava - Veluthedathu",
            "Yezhava - Veluthedathu Nair",
            "Yezhava - Vettuva",
            "Yezhava - Vettuva Gounder",
            "Yezhava - Vilakithala Nair",
            "Yezhava - Vishwakarma",
            "Yezhava - Vilakithala Nair",
            "Yezhava - Vishwakarma",
            "Yogi",
            "Yogi - Nath",
            "Yogi - Nath - Jogi",
            "Yogi - Nath - Nathpanthi",
            "Yogi - Nath - Udasin",
            "Yogi - Nath - Udasi",
            "Yogi - Nath Jogi",
            "Yogi - Nath Nathpanthi",
            "Yogi - Nath Udasin",
            "Yogi - Nath Udasi",
            "Yogi - Vairagi",
            "Yogi - Vairagi - Bairagi",
            "Yogi - Vairagi - Udasi",
            "Yogi - Vairagi Bairagi",
            "Yogi - Vairagi Udasi",
            "Yogi - Vairagi Vairagi",
            "Yogi - Vairagi Vairagi Udasi",
            "Yogi - Vairagi Vairagi-Udasi",
            "Yogi - Vairagi-Vairagi",
            "Yogi - Vairagi-Vairagi Udasi",
            "Yogi - Vairagi-Vairagi-Udasi",
            "Yogi - Vairagi-Vairagi/Udasi",
            "Yogi - Vairagi/Vairagi",
            "Yogi - Vairagi/Vairagi-Udasi",
            "Yogi - Vairagi/Vairagi/Udasi",
            "Yogi - Vairagi/Udasi",
            "Yogi - Udasi",
            "Yogi - Udasi - Nath",
            "Yogi - Udasi - Vairagi",
            "Yogi - Udasi Nath",
            "Yogi - Udasi Vairagi",
            "Yuvarlu",
            "Zamindar",
            "Zoroastrian",
            "Zoroastrian - Parsi",
            "Zoroastrian - Parsi - Irani",
            "Zoroastrian - Parsi - Kutchi",
            "Zoroastrian - Parsi - Varsi",
            "Zoroastrian - Parsi Irani",
            "Zoroastrian - Parsi Kutchi",
            "Zoroastrian - Parsi Varsi"
        ]
    },
    {
        religion: "Muslim",
        castes: [
            "Ansari",
            "Arain",
            "Awan",
            "Bengali",
            "Dawoodi Bohra",
            "Dekkani",
            "Dudekula",
            "Jat",
            "Khoja",
            "Lebbai",
            "Mapila",
            "Maraicar",
            "Memon",
            "Mughal",
            "Pathan",
            "Qureshi",
            "Rajput",
            "Rowther",
            "Shafi",
            "Sheikh",
            "Shia",
            "Shia Bohra",
            "Shia Imami Ismaili",
            "Shia Ithna ashariyyah",
            "Shia Zaidi",
            "Siddiqui",
            "Sunni",
            "Sunni Ehle-Hadith",
            "Sunni Hanafi",
            "Sunni Hunbali",
            "Sunni Maliki",
            "Sunni Shafi",
            "Syed",
        ]
    },
    {
        religion: "Christian",
        castes: [
            "Anglo Indian",
            "Basel Mission",
            "Born Again",
            "Bretheren",
            "CMS",
            "Cannonite",
            "Catholic",
            "Catholic Knanya",
            "Catholic Malankara",
            "Chaldean Syrian",
            "Cheramar",
            "Christian Nadar",
            "Church of North India (CNI)",
            "Church of South India (CSI)",
            "Convert",
            "Evangelical",
            "IPC",
            "Indian Orthodox",
            "Intercaste",
            "Jacobite",
            "Jacobite Knanya",
            "Knanaya",
            "Knanaya Catholic",
            "Knanaya Jacobite",
            "Knanaya Pentecostal",
            "Knanya",
            "Latin Catholic",
            "Malankara",
            "Malankara Catholic",
            "Manglorean",
            "Marthoma",
            "Methodist",
            "Mormon",
            "Nadar",
            "Orthodox",
            "Pentecost",
            "Presbyterian",
            "Protestant",
            "RCSC",
            "Roman Catholic",
            "Salvation Army",
            "Scheduled Caste (SC)",
            "Scheduled Tribe (ST)",
            "Seventh day Adventist",
            "Syrian",
            "Syrian Catholic",
            "Syrian Orthodox",
            "Syro Malabar"
        ]
    },
    {
        religion: "Sikh",
        castes: [
            "Ahluwalia",
            "Arora",
            "Clean Shaven",
            "Gursikh",
            "Jat",
            "Kamboj",
            "Kesadhari",
            "Khatri",
            "Kshatriya",
            "Labana",
            "Mazhbi/Majabi",
            "Rajput",
            "Ramdasia",
            "Ramgharia",
            "Ravidasia",
            "Saini"
        ]
    },
    {
        religion: "Jain",
        castes: [
            "Digambar",
            "Porwal",
            "Shwetamber",
            "Vania",
        ]
    },
    {
        religion: "Buddhist",
        castes: []
    },
    {
        religion: "Parsi",
        castes: []
    },
    {
        religion: "Jewish",
        castes: []
    },
    {
        religion: "Spiritual - Not Religious",
        castes: []
    }
]
export { pricingTable, coupleSlider, user, hobbies, incomeList, languageList, heightList, qualificationList, workingWithList, occupationList, religionAndCommunityList }